// extracted by mini-css-extract-plugin
export default {"Heading":"no-data-card-module__Heading__HEmTI3A","Box":"no-data-card-module__Box__YhqSGFH"};